import { Component } from '@angular/core';
import { BenefitsButtonComponent } from './benefits-button/benefits-button.component';
import { BenefitsService } from '@services/benefits.service';
import { BenefitsContainerComponent } from './benefits-container/benefits-container.component';

@Component({
  selector: 'app-benefits',
  standalone: true,
  imports: [
    BenefitsButtonComponent,
    BenefitsContainerComponent
  ],
  viewProviders: [
    BenefitsService,
  ],
  templateUrl: './benefits.component.html',
  styleUrl: './benefits.component.css'
})
export class BenefitsComponent {

}
